import React, { useCallback, useEffect, useState } from "react";

const OrientationLocker: React.FC = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const checkAndSetOverlay = useCallback(() => {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    if (isMobile && isPortrait) {
      setShowOverlay(true);
    } else {
      setShowOverlay(false);
    }
  }, []);

  useEffect(() => {
    checkAndSetOverlay();
    window.addEventListener("resize", checkAndSetOverlay);
    return () => {
      window.removeEventListener("resize", checkAndSetOverlay);
    };
  }, [checkAndSetOverlay]);

  if (!showOverlay || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[100] p-4 bg-white border border-gray-200 rounded-lg shadow-xl">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="text-sm font-bold text-gray-900">
            Landscape Mode Recommended
          </h3>
          <p className="mt-1 text-xs text-gray-600">
            This website is best viewed in landscape mode.
          </p>
        </div>
        <button
          onClick={() => setIsDismissed(true)}
          className="ml-4 text-gray-400 hover:text-gray-600 focus:outline-none"
          aria-label="Close warning"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default OrientationLocker;
